import { render, staticRenderFns } from "./HomeMedico.vue?vue&type=template&id=8a9ebeac&scoped=true"
import script from "./HomeMedico.vue?vue&type=script&lang=js"
export * from "./HomeMedico.vue?vue&type=script&lang=js"
import style0 from "./HomeMedico.vue?vue&type=style&index=0&id=8a9ebeac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9ebeac",
  null
  
)

export default component.exports